const Realize = {
	Input: window.Input,
};

export default class Input extends Realize.Input {

    renderLabelCustom() {
      var inputValue = this.getInputComponentValue();
      var isActive = this.labelIsActive(inputValue);
  
      return (
        <Label {...this.propsWithoutCSS()} id={this.getInputComponentId()} active={isActive} className={'hidden'} label={'Quantidade de itens por página'} />
      );
    }

    renderInputCustom() {
        return (
          <div className={this.inputClassName()} id={this.getInputContainerId()}>
            {this.renderComponentInput()}
            {this.renderLabelCustom()}
            {this.renderInputErrors()}
          </div>
        );
      }

    render () {
        var renderFunction = 'render' + S(this.props.component).capitalize().s + 'Input';
        var renderLabel = this.props.renderLabel;
        
        if(this.hasOwnProperty(renderFunction)) {
            return this[renderFunction]();
        } else if(!renderLabel) {
            return this.renderInputWithoutLabel();
        } else {
            return this.renderInputCustom();
        }
    }
}